<template><div class="room-selector" :class="{ '_selected': isBooked(), 'toolbar': 'toolbar' === props.For }">

    <div  @click.stop.prevent="detail_click" class="room-selector__wrapper">
        <span class="room-selector__name">{{props.Cabin.name}}</span>
        <Mest v-if="!isBooked()" class="room-selector__mest" :acc="props.Cabin.acc" />
        <span v-if="isBooked()" class="room-selector__mest">{{gostey(occupation)}}</span>
    </div>

    <RoomModal :Cabin="props.Cabin" :CabinSet="props.CabinSet" 
        :modalShown="isModalShown" @input="set_isModalShown" />

</div></template>


<script setup>
import {ref, unref, computed, onMounted, watch, nextTick} from 'vue'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import Mest from '@/comp/CruiseHead/Mest.vue'
import { numWord } from '@/util.js'
import RoomModal from './RoomModal.vue'

const cstore = useCruiseStore()
const bookCabins = useCabinsStore()

const props = defineProps({
    Cabin : Object,
    CabinSet : Object,
    For: [String]
})

const isModalShown = ref(false)
const set_isModalShown = nov => isModalShown.value = nov
const detail_click = () => {
    isModalShown.value = true
}


const occupation = bookCabins.getOccupation( props.Cabin.id )

const isBooked = () => bookCabins.isBooked( props.Cabin.id )

/*
будет размещено 5 человек
размещено 5
2 места (+1)
5 гостей
*/
const gostey = ({adult, child, infant}) => {
    const num = adult+child+infant
    const ret = numWord(num, ['гость', 'гостя', 'гостей'])
    return ret
}

</script>
